import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'

interface Props {
  resourceIds: number[]
  setResourceIds: (ids: number[]) => void
}

const ResourceTypes = ({ resourceIds, setResourceIds }: Props) => {
  return (
    <EmployeeSelectorV2
      multiple
      useAccessId
      value={resourceIds}
      onChange={(state) => {
        if (state.type === 'manual') {
          setResourceIds(state.ids)
        }
      }}
      options={{ disableSelectAll: true }}
    />
  )
}
export default ResourceTypes
